module.exports = __webpack_public_path__ + "assets/img/shredder.b041e370.png";